import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagAdd2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShoppingBagAdd2"><Path fillRule="evenodd" clipRule="evenodd" d="M7.9982 6C7.9982 3.79086 9.78906 2 11.9982 2C14.2073 2 15.9982 3.79086 15.9982 6V7H18.3953L19.4323 14H15.9982V17H12.9982V22H3.37891L5.60113 7H7.9982V6ZM14.4982 7V6C14.4982 4.61929 13.3789 3.5 11.9982 3.5C10.6175 3.5 9.4982 4.61929 9.4982 6V7H14.4982Z" fill="currentColor"/><Path d="M21.9982 18.5H18.9982V15.5H17.4982V18.5H14.4982V20H17.4982V23H18.9982V20H21.9982V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBagAdd2;
